// ======== style import ======== //
import '../../../src/index.css'
import '../../../src/_template/assets/sass/style.scss'

// ========== plugin import ========== //
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

// ========= module import =========== //
import { MenuComponent } from '../assets/ts/components/MenuComponent';
import Footer from './components/footer/Footer';
import HeaderWrapper from './components/header/HeaderWrapper';
import Sidebar from './components/sidebar/Sidebar';
import { PageDataProvider } from './core/PageData';

import 'react-toastify/dist/ReactToastify.css';
import { ToggleComponent } from '../assets/ts/components/ToggleComponent';

// import { Provider, useSelector, useDispatch } from "react-redux";
import store from '../../app/redux/store';

const MasterLayout = () => {
    const location = useLocation()
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
            ToggleComponent.reinitialization()
        }, 500);
    }, [location.key])
    return (
        <>
            {/* <Provider store={store}> */}
                <PageDataProvider>
                    <ToastContainer/>
                    <div className='d-flex flex-column flex-root app-root' id='sai_app_root'>
                        <div className='app-page flex-column flex-column-fluid' id='sai_app_page'>
                            <HeaderWrapper />
                            <div className='app-wrapper flex-column flex-row-fluid' id='sai_app_wrapper'>
                                <Sidebar />
                                <div className='d-flex flex-column flex-row-fluid vh-90' id='sai_app_main'>
                                    <div className='d-flex flex-column flex-column-fluid flex-grow-1'>
                                        <div id="sai_app_content" className="app-content flex-column-fluid">
                                            <div id="sai_app_content_container" className="app-container container-xxl">
                                                <Outlet />
                                            </div>
                                        </div>
                                    </div>
                                    <Footer />
                                </div>
                            </div>
                        </div>
                    </div>
                </PageDataProvider>
            {/* </Provider> */}
        </>
    )
}

export default MasterLayout;